<template>
    <div class="info_page">
        <div class="back_btn" @click="$router.go(-1)"><i class="el-icon-arrow-left"></i></div>
        <div class="avatar" flex-center>
            <el-upload class="avatar-uploader" :action="fileApi+'/api/front/upload/?storage=ali_oss'" :show-file-list="false" 
            :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" accept=".jpg,.png,.jpeg">
                <div class="upload_wrap">
                    <img :src="userInfo.avatarurl?userInfo.avatarurl:require('./img/unAvatar.png')" class="pic" />
                    <p class="text"><img src="./img/icon_img10.png" /> 修改头像</p>
                </div>
            </el-upload>
        </div>
        <div class="info_list">
            <div class="info_item flex jb ac">
                <div class="title">昵称</div>
                <div class="text">
                    <p>{{userInfo.nickname}}</p>
                </div>
            </div>
            <div class="info_item flex jb ac">
                <div class="title">ID</div>
                <div class="text">
                    <p>{{userInfo.uid}}</p>
                </div>
            </div>
            <div class="info_item flex jb ac">
                <div class="title">手机号</div>
                <div class="text">
                    <p v-if="userInfo.phone">{{userInfo.phone}}</p>
                    <span class="btn"
                            v-else
                            @click="bindphone">绑定手机</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        data() {
            return {
                fileApi:FILE_API_SERVER
            }
        },
        computed: {
            userInfo() {
                return this.$store.state.userInfo;
            },
        },
        created() {
        
        },
        methods: {
            fetchProfile(){
                this.$http.get(`/front/user/profile/`).then(res => {
                    if (res.status == '200') {
                        this.$store.commit('setUserInfo', res.data)
                        this.$store.commit('setIsLogin', true)
                        this.$store.commit('setShowLogin', false)
                        localStorage.setItem("userinfo", JSON.stringify(res.data));
                        localStorage.setItem("invite_code", res.data.invite_code);
                    }
                }).finally(() => {

                })
            },
            //上传头像
            handleAvatarSuccess(response, uploadFile) {
                let img_url = response.data.file_full_url
                this.userInfo.avatarurl = URL.createObjectURL(uploadFile.raw)
                this.$http.post(`/front/user/profile/avatar/`,{img_url:img_url}).then(res=>{
                    this.fetchProfile()
                })
            },
            beforeAvatarUpload(rawFile) {
                if (rawFile.type !== 'image/jpeg' && rawFile.type !== 'image/png') {
                    this.$message({
                        type: 'warning',
                        message: "请上传jpg或者png格式的图片",
                    })
                    return false
                } else if (rawFile.size / 1024 / 1024 > 2) {
                    this.$message({
                        type: 'warning',
                        message: "请上传2M以内的图片",
                    })
                    return false
                }
                return true
            },
            //点击绑定手机
            bindphone () {
                this.$store.commit('setShowBindPhone', true)
            },
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .info_page{
        padding: 20px;
        max-width: 600px;
        margin: 0 auto;
        position: relative;
        .back_btn{
            position: absolute;
            border: 2px solid #949ba4;
            top: 20px;
            left: 20px;
            padding: 5px;
            border-radius: 999px;
            i{
                font-size: 16px;
                color: #fff;
            }
        }
        .avatar{
            margin: 30px 0 15px;
            .upload_wrap{
                .pic {
                    width: 70px;
                    height: 70px;
                    border-radius: 50%;
                    margin-bottom: 5px;
                    margin-top: 5px;
                }
                .text {
                    font-size: 14px;
                    color: #fff;
                    img {
                        width: 14px;
                        height: 14px;
                        display: inline-block;
                        margin-right: 5px;
                    }
                }
            }
        }
        .info_item{
            background-color: #24262e;
            border-radius: 12px;
            margin: 10px 0;
            height: 54px;
            padding: 0 20px;
            .text {
                font-size: 14px;
                color: #b0b0b0;
                .btn {
                    padding: 0 14px;
                    display: block;
                    line-height: 34px;
                    cursor: pointer;
                    background-color: #5865f2;
                    color: #fff;
                    border-radius: 4px;
                    &:hover {
                        background-color: rgba(88, 101, 242, 0.867);
                    }
                }
            }
        }
    }
</style>